export const COMPANY = {name:"BLUEPRINT HOLDINGS GROUP PTY LTD", abn:"88 691 704 980", acn:"691 704 980", supportEmail:"support@orrbbit.com"};
